import React from 'react';
import EditAction, { EditActionProps } from './EditAction/EditAction';
import { DeleteAction, DeleteActionProps } from './DeleteAction/DeleteAction';
import ModalFormAction, {
  ModalFormActionProps,
} from './ModalFormAction/ModalFormAction';
import ModalConfirmationAction, {
  ModalConfirmationActionProps,
} from './ModalConfirmationAction/ModalConfirmationAction';
import DownloadAction, {
  DownloadActionProps,
} from './DownloadAction/DownloadAction';
import PdfPreviewAction, {
  PdfPreviewActionProps,
} from './PdfPreviewAction/PdfPreviewAction';
import NavigateAction, {
  NavigateActionProps,
} from './NavigateAction/NavigateAction';
import { InputValueType } from '../../../../../../hooks/useForm/useForm';
import RemoveAction, { RemoveActionProps } from './RemoveAction/RemoveAction';

export type VisibilityConfig = {
  field?: string;
  value?: InputValueType;
  values?: InputValueType[];
  not?: boolean;
  specificValue?: boolean;
};

export enum ActionTableCellVariant {
  'edit' = 'edit',
  'delete' = 'delete',
  'modal' = 'modal',
  'modalConfirmation' = 'modalConfirmation',
  'download' = 'download',
  'pdfPreview' = 'pdfPreview',
  'navigation' = 'navigation',
  'remove' = 'remove',
}

export type ActionTableCellProps = { visibilityConfig?: VisibilityConfig } & (
  | (EditActionProps & {
      variant: ActionTableCellVariant.edit;
    })
  | (DeleteActionProps & {
      variant: ActionTableCellVariant.delete;
    })
  | (ModalFormActionProps & {
      variant: ActionTableCellVariant.modal;
    })
  | (ModalConfirmationActionProps & {
      variant: ActionTableCellVariant.modalConfirmation;
    })
  | (DownloadActionProps & {
      variant: ActionTableCellVariant.download;
    })
  | (PdfPreviewActionProps & {
      variant: ActionTableCellVariant.pdfPreview;
    })
  | (NavigateActionProps & {
      variant: ActionTableCellVariant.navigation;
    })
  | (RemoveActionProps & {
      variant: ActionTableCellVariant.remove;
    })
);

export const ActionTableCell = (props: ActionTableCellProps) => {
  switch (props.variant) {
    case ActionTableCellVariant.edit:
      return <EditAction {...props} />;
    case ActionTableCellVariant.delete:
      return <DeleteAction {...props} />;
    case ActionTableCellVariant.modal:
      return <ModalFormAction {...props} />;
    case ActionTableCellVariant.modalConfirmation:
      return <ModalConfirmationAction {...props} />;
    case ActionTableCellVariant.download:
      return <DownloadAction {...props} />;
    case ActionTableCellVariant.pdfPreview:
      return <PdfPreviewAction {...props} />;
    case ActionTableCellVariant.navigation:
      return <NavigateAction {...props} />;
    case ActionTableCellVariant.remove:
      return <RemoveAction {...props} />;
    default:
      return null;
  }
};

export default ActionTableCell;
